interface Props {
  large?: boolean;
  /** Static grey dot, no pulse (used for the offline/connection-lost state). */
  off?: boolean;
  color?: string;
}

/** Status dot. Pulsing green by default; static grey when `off`. */
export function PulseDot({ large, off, color }: Props) {
  const cls = ['dot', large ? 'dot--lg' : '', off ? 'dot--off' : ''].filter(Boolean).join(' ');
  const style = color && !off ? { background: color } : undefined;
  return (
    <span className={cls} aria-hidden="true">
      <span className="dot__core" style={style} />
      <span className="dot__ring" style={style} />
    </span>
  );
}
